export const Theme = {
    colors: {
        white: "#fff",
        gray: {
            100: "#F7F7F7",
            200: "#EDEDED",
            300: "#dee2e6",
            400: "#D8D8D8",
            500: "#adb5bd",
            600: "#999999",
            650: "#767676",
            700: "#595959",
            800: "#343a40",
            900: "#212529",
        },
        black: "#000",
        blue: "#333366",
        indigo: "#3573b1",
        purple: "#333366",
        pink: "#E71921",
        red: "#E71921",
        orange: "#ffb733",
        yellow: "#ffb733",
        green: "#218748",
        teal: "#20c997",
        cyan: "#52addb",
        background_gray: "#f7f7f7",
        dark_background_gray: "#d8d8d8",
        text_dark_gray: "#595959",
        background_hover_gray: "#EDEDED",
        light_gray: "#DFDFDF",
    },
};
